import React from 'react';

// constants
import { DASHBOARD_TOOLBAR_TITLE} from "./constants";

// redux
import withShipment from "../../withShipment";
import {userInfoSelector} from "../../redux/selectors/auth";


import DateFnsUtils from "@date-io/date-fns";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";


import ErrorFeedbackBar from '../global/ErrorFeedbackBar';

import CustomToolbar from "../global/CustomToolbar";
import RefreshIcon from "@material-ui/icons/Refresh";
import { HourglassEmptyTwoTone} from "@material-ui/icons";
import {refreshSelector} from "../../redux/selectors/dashboard";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography
} from '@material-ui/core';
import axios from "axios";
import {BASE_URL} from "../global/Server/endpoints";



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardsData: [],
      dashboardCards: [],
    };
  };

  componentDidMount() {
    this.refreshComponent();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps.refresh !== this.props.refresh) {
      this.refreshComponent();
    }

  }

  fetchDashboardFolders = async () => {
    try {
      const token = localStorage.getItem("token");


      const res = await axios.post(
          `${BASE_URL}/dashboardFolder/list`,
          { companyId: this.props.userInfo.company},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );

      if (res.data.success) {
        let folderCard = [];

        if (this.props.userInfo.authority.includes("ROLE_ADMIN")) {
          // Admin sees all folders
          folderCard = res.data.data;
        } else {
          // Non-admin sees only selected folders
          folderCard = res.data.data.filter(card =>
              this.props.userInfo.selectedFolders.includes(card.dashboardFolderId)
          );
        }

        this.setState({ dashboardCards: res.data.data, cardsData: folderCard });
      }
      else {
        this.openFeedback("error", res.data.message || "Failed to load folders");
      }
    } catch (e) {
      console.error("Fetch error:", e);
      this.openFeedback("error", "Server error while fetching folders");
    }
  };


  refreshComponent = () => {
    this.fetchDashboardFolders();
  };


  render() {


    let headerButtons = [];

      headerButtons.push({
        icon: this.props.refreshing ? <HourglassEmptyTwoTone /> : <RefreshIcon />,
        handler: this.refreshComponent,
        title: this.props.refreshing ? 'Refreshing...' : 'Refresh',
        disabled: this.props.refreshing,
      });


    return (
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ErrorFeedbackBar />
          <CustomToolbar
            title={DASHBOARD_TOOLBAR_TITLE}
            createTitle={'Dashboard'}
            backTitle={'Back To Menu'}
            onClick={() => {}}
            headerButtons={headerButtons}
          />
        </MuiPickersUtilsProvider>

        <Grid container spacing={3} style={{ padding: 24,width:'100%' }}>
          {this.state.cardsData.map((card, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>

                <Card
                    style={{
                      cursor: 'pointer',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      borderRadius: 16,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                    }}
                    onClick={() => this.props.history.push({
                      pathname: '/file-manager',
                      state: { selectedFolder: card.title, parentId: card.dashboardFolderId }
                    })}
                  >
                  <CardMedia style={{backgroundColor:'#dcdabb', display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                    <img
                        src={card.imageUrl}
                        alt={card.title}
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  </CardMedia>
                  <CardContent>
                    <Typography variant="h6" component="h2" align="center">
                      {card.title}
                    </Typography>
                  </CardContent>
                </Card>

              </Grid>
          ))}
        </Grid>

      </>
    )
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  refresh: refreshSelector(state),
});

const actionCreators =
  {
  }


Dashboard.propTypes = {

}

Dashboard.defaultProps = {

}

export default withShipment({
  mapStateToProps,
  actionCreators
}, Dashboard);